import React, { FC } from 'react';
import cn from 'classnames';
import { DialogContentProps } from '../../types';
import { NumberColValue } from '../../../GridV2/types';
import { Row, Col } from '../../../GridV2';

import Action from './Action';

export interface AlertActionsProps
  extends Pick<
    DialogContentProps,
    'type' | 'cancelAction' | 'confirmAction' | 'dark'
  > {
  totalInnerCols: {
    xs: NumberColValue;
    sm: NumberColValue;
    md: NumberColValue;
    lg: NumberColValue;
  };
  hasMoreElements?: boolean;
}

const AlertActions: FC<AlertActionsProps> = ({
  type = 'm',
  cancelAction,
  confirmAction,
  dark,
  totalInnerCols,
  hasMoreElements,
}) => {
  const className = hasMoreElements ? 'mb-32' : '';

  if (cancelAction && confirmAction) {
    return (
      <Row
        className={cn('flex flex-col-reverse sm:flex-row', className)}
        totalCols={totalInnerCols}
      >
        <Col
          className="flex items-center justify-center"
          xs={totalInnerCols.xs}
          sm={(totalInnerCols.sm / 2) as NumberColValue}
          md={(totalInnerCols.md / 2) as NumberColValue}
          lg={(totalInnerCols.lg / 2) as NumberColValue}
        >
          <Action
            type={type}
            action={cancelAction}
            actionType="cancel"
            dark={dark}
          />
        </Col>
        <Col
          className="flex items-center justify-center"
          xs={totalInnerCols.xs}
          sm={(totalInnerCols.sm / 2) as NumberColValue}
          md={(totalInnerCols.md / 2) as NumberColValue}
          lg={(totalInnerCols.lg / 2) as NumberColValue}
        >
          <Action
            type={type}
            action={confirmAction}
            actionType="confirm"
            dark={dark}
          />
        </Col>
      </Row>
    );
  }

  return (
    <Action
      type={type}
      action={cancelAction || confirmAction}
      actionType={cancelAction ? 'cancel' : 'confirm'}
      dark={dark}
      className={className}
    />
  );
};

export default AlertActions;
